import axios, { type AxiosInstance } from "axios"
import { typedEnv } from "../config/typedEnv"

interface ITiendanudeProductCategory {
  id: string
  name: string
}

interface ITiendanudeProductVariant {
  id: string
  name: string
  position: number
  sku: string
  barcode?: number | null
  imageUrl: string
}

export interface ProductTndb {
  id: string
  name: string
  brand?: string
  description?: string
  variants: ITiendanudeProductVariant[]
  url: string
  categories: ITiendanudeProductCategory[]
  currency: string
}

export interface TiendanubeProductsResponse {
  products: ProductTndb[]
  hasNext: boolean
}

class TintVTOAxiosService {
  apiKey: string = typedEnv.VITE_ADMIN_API_KEY
  private axiosInstance: AxiosInstance

  constructor() {
    this.axiosInstance = axios.create({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-api-key": this.apiKey,
      },
    })
  }

  // async getTiendanubeProducts(
  //   username: string,
  //   page: number = 1,
  //   perPage: number = 100
  // ): Promise<{ products: ProductTndb[]; pagination: any }> {
  //   const response = await this.axiosInstance.get(
  //     `${
  //       import.meta.env.VITE_TIENDANUBE_API_URL
  //     }/api/v2/products?username=${username}&page=${page}&per_page=${perPage}`
  //   )
  //
  //   const products: ProductTndb[] = response?.data?.data ?? []
  //   const pagination = response?.data?.pagination ?? {}
  //
  //   return {
  //     products,
  //     pagination,
  //   }
  // }

  async getTiendanubeProducts(
    username: string,
    page?: number,
    productName?: string,
    perPage?: number
  ): Promise<TiendanubeProductsResponse> {
    const params = new URLSearchParams({
      username,
      ...(page && { page: page.toString() }),
      ...(productName && { name: productName }),
      ...(perPage && { per_page: perPage.toString() }),
    })

    const response = await this.axiosInstance.get(
      `${typedEnv.VITE_TIENDANUBE_API_URL}/api/v1/products?${params.toString()}`
    )
    const products: ProductTndb[] = response?.data?.products ?? []
    const hasNext: boolean = response?.data?.hasNext ?? false

    return {
      products,
      hasNext,
    }
  }

  async updateMerchantSkus(shopId: string, added: string[], removed: string[]) {
    const response = await this.axiosInstance.post(
      `${typedEnv.VITE_TIENDANUBE_API_URL}/api/v1/merchant/${shopId}/skus`,
      {
        added,
        removed,
      }
    )
    return response.data
  }
}

const tintVTOAxiosService = new TintVTOAxiosService()
export const useTintVTOAxiosService = () => tintVTOAxiosService
